package kz.dentalcrm.app.data.network

import io.ktor.client.HttpClient
import io.ktor.client.request.setBody
import io.ktor.http.ContentType
import io.ktor.http.HttpMethod
import io.ktor.http.contentType
import io.ktor.http.path
import kz.dentalcrm.app.data.network.request_model.LoginBody
import kz.dentalcrm.app.core.network.handle
import kz.dentalcrm.app.data.network.response_model.LoginResponse

class AuthApi(
    private val httpClient: HttpClient,
) {

    suspend fun login(email: String, password: String) =
        httpClient.handle<LoginResponse> {
            contentType(ContentType.Application.Json)
            url {
                path("api/v1/login")
            }
            setBody(LoginBody(email, password))
            method = HttpMethod.Post
        }

}